export default "__VITE_ASSET__6d01b4e8__"